import { Helmet } from "react-helmet-async";

const DOMAIN = "https://www.zddesignagency.com";

export default function Seo({ title, description, path, ogImage, ogImageAlt, noindex }) {
  const url = `${DOMAIN}${path}`;
  const image = `${DOMAIN}${ogImage || "/og-image.jpg"}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : null}
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={ogImageAlt || title} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
